import { Fragment, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { ProductCardSkeleton } from "../../Skeleton/productCardSkeleton";
import { ProductListSkeleton } from "../../Skeleton/ProductListSkeleton";
import { Index } from "react-instantsearch";

export const ProductSkeletonLoader = () => {
  const { isGridView } = useContext(GlobalContext);
  return (
    <Fragment>
      {isGridView ? (
        <div className={"col-lg-12"}>
          <div className={"productCard-wrapper"}>
            {[1, 2, 3, 4].map((index) => (
              <div className={"productCard"} key={index}>
                <ProductCardSkeleton />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div key={0} className="col-lg-12">
          {[1, 2, 3, 4].map((index) => (
            <ProductListSkeleton key={index} />
          ))}
        </div>
      )}
    </Fragment>
  );
};
